import React, { Suspense } from "react";
import { Route, Routes, Navigate } from "react-router-dom";
// import { MsalProvider } from "@azure/msal-react";
// import { msalInstance } from "../src/pages/login/msalConfig";

import AppLoading from "./components/Error/AppLoading";
import LoginPage from "./pages/login/LoginPage";
import Dashboard from "./pages/dashboard";
import Forgetpass from "./pages/officer/auth/forgotpasscode";
import VerifyOtp from "./pages/officer/auth/forgotpasscode/verifyotp";
import NewPass from "./pages/officer/auth/forgotpasscode/newpassword";
import PassSuccess from "./pages/officer/auth/forgotpasscode/sucess";
import Unauthorized from "./pages/unauthorized";
import Missing from "./pages/missing";
import LeadManagement from "./pages/lead-management";
import FrameworkAssignment from "./pages/framework/framework";

// ✅ Check token
const isAuthenticated = () => {
  const userData = localStorage.getItem("userData");
  if (!userData) return false;

  const parsed = JSON.parse(userData);
  return !!parsed?.access_token;
};

// ✅ Protected route wrapper
const ProtectedRoute = ({ element }: { element: JSX.Element }) => {
  return isAuthenticated() ? element : <Navigate to="/" />;
};

const App = () => {
  return (
    <Suspense fallback={<AppLoading />}>
      <Routes>
        {/* Public routes */}
        <Route path="/" element={<LoginPage />} />
        <Route path="/forget-password" element={<Forgetpass />} />
        <Route path="/verifyotp" element={<VerifyOtp />} />
        <Route path="/new-password" element={<NewPass />} />
        <Route path="/success-page" element={<PassSuccess />} />

        {/* Protected routes */}
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute
              element={
                // <MsalProvider instance={msalInstance}>
                  <Dashboard />
                // </MsalProvider>
              }
            />
          }
        />

        <Route
          path="/lead-management"
          element={<ProtectedRoute element={<LeadManagement />} />}
        />

        <Route
          path="/framework"
          element={<ProtectedRoute element={<FrameworkAssignment />} />}
        />

        <Route path="/unauthorized" element={<Unauthorized />} />
        <Route path="/404" element={<Missing />} />
        <Route path="*" element={<Navigate to="/404" />} />
      </Routes>
    </Suspense>
  );
};

export default App;
